'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* -----------  PASSWORD RECOVERY  ------------------------ */

var _ref = _jsx('h4', {}, void 0, 'Thanks!');

var PasswordRecoveryResponse = _react2['default'].createClass({
    displayName: 'PasswordRecoveryResponse',


    propTypes: {
        // Currently ignored for security reasons (message ambiguity)
        'isSuccessful': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {
        $(document).foundation();
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    render: function render() {

        var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
        var mailtoLink = "mailto:" + supportEmail + "?subject=" + encodeURIComponent("Password Reset");
        var msg = _jsx('span', {}, void 0, _jsx('p', {}, void 0, 'If that is a valid address, we have sent an email to it to reset your password.'), _jsx('p', {}, void 0, 'If you\'re still experiencing difficulties, please contact us at ', _jsx('a', {
            href: mailtoLink
        }, void 0, supportEmail), '.'));

        return _jsx('div', {
            className: 'row text-center'
        }, void 0, _jsx('div', {
            className: 'columns small-12'
        }, void 0, _ref, msg));
    }
});

module.exports = PasswordRecoveryResponse;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/password-recovery-response.jsx
 ** module id = 756
 ** module chunks = 0
 **/